<template>
  <section :class="['coupontype',status ? 'active' : '']"  v-on:click="chooseType(id)">
    <span>{{coupontype}}券</span>
    <p>{{coupontip}}</p>
    <img :src = 'imgsrc' />
    <img class= "checked" v-if="status" :src ="checked" />
    <img class= "activity" v-if="activitysrc" :src ="activitysrc" />
  </section>
</template>

<script>
import Check from 'Images/check.png'
export default {
  name: 'CouponType',
  componentName: 'CouponType',
  methods: {
    chooseType: function (id) {
      this.selectType(id)
    }
  },
  data: function () {
    return {
      checked: Check
    }
  },
  props: {
    coupontype: String,
    coupontip: String,
    imgsrc: String,
    id: Number,
    selectType: Function,
    status: Boolean,
    activitysrc: [String, Boolean]
  }
}
</script>

<style lang="stylus">
.coupontype{
  width 184px
  height 94px
  position relative
  background: #FFFFFF
  box-shadow: 0 4px 14px 0 rgba(0,0,0,0.10)
  display: inline-block
  margin-right :20px
  padding-top 6px
  padding-left 16px
  margin-bottom 10px
  &.active{
    border:solid 1px #3468FF;
    background: none;
  }
  span{
    font-size: 14px;
    color: #333333;
  }
  p{
    font-size: 12px;
    color: #999999;
    line-height: 10px;
  }
  img {
    width 100px
    position absolute
    right 0px
    bottom 0px
  }
  img.checked{
    width 35px
  }
  img.activity{
    width 72px
    height 20px
    right 0px
    position absolute
    top 0px
  }
}

</style>
